module.exports = __webpack_public_path__ + "assets/img/icon_nor_client.ddc2fd90.svg";